// test2286
(2286 && 0);
